import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Cost} from "../../models/cost";
import {ServiceLocation} from "../../models/service-location";
import Helpers from "../../utils/helpers";

@Injectable()
export class ServiceLocationControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public createServiceLocation(serviceId: string, serviceLocation: ServiceLocation): Observable<ServiceLocation> {
    Helpers.trimRecursiveObj(serviceLocation);
    const body = JSON.stringify(serviceLocation);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/service_location", body) as Observable<ServiceLocation>;
  }

  public getServiceLocations(serviceId: string): Observable<ServiceLocation[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/service_location") as Observable<ServiceLocation[]> ;
  }

  public saveServiceLocation<T>(serviceId: string, registrationLocation: ServiceLocation): Observable<any> {
    Helpers.trimRecursiveObj(registrationLocation);
    const body = JSON.stringify(registrationLocation);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/service_location", body);
  }

  public deleteServiceLocation<T>(serviceLocationId: string) {
    return this.http.delete(this.baseUrl + "service_location/" + serviceLocationId, {responseType: "text"});
  }

  public getServiceLocation(serviceLocationId: string): Observable<ServiceLocation> {
    return this.http.get(this.baseUrl + "service_location/" + serviceLocationId) as Observable<ServiceLocation>;
  }
}
